import { createFileRoute } from "@tanstack/react-router";
import { DocumentReader } from "~/features/documents/document-reader";

export const Route = createFileRoute("/_app/documents/product-overview")({
  component: () => <DocumentReader id="product-overview" />,
});
